<script lang="ts" setup>
const bannerStore = useBannerStore();

interface Props {
  configData: {
    Title?: string;
    Text?: string;
    Icon?: string;
    BgColor?: string;
    LinkButtonUrl?: string;
    LinkButtonText?: string;
  };
}

const props = defineProps<Props>();
bannerStore.set(
  props.configData.Title,
  props.configData.Text,
  props.configData.Icon,
  props.configData.BgColor,
  props.configData.LinkButtonUrl,
  props.configData.LinkButtonText,
);
</script>

<style scoped></style>
